export default function IconBtnZoomIn() {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16Z'
        fill='white'
      />
      <path
        d='M0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16Z'
        stroke='#A3A3A3'
      />
      <path
        d='M21.9596 10.273L18.7865 13.4461L18.4335 13.7991L18.786 14.1527L20.1289 15.4997H16.5V11.8734L17.8398 13.2132L18.193 13.5664L18.5466 13.2136L21.7264 10.0398L21.9596 10.273ZM15.5 20.1285L14.1531 18.7856L13.7995 18.4331L13.4465 18.7861L10.2734 21.9592L10.0401 21.726L13.2139 18.5462L13.5668 18.1927L13.2136 17.8395L11.8738 16.4997H15.5V20.1285Z'
        fill='#121212'
        stroke='#121212'
      />
    </svg>
  )
}
